import React, { useContext } from 'react'
import { Link, NavLink } from 'react-router-dom';

import { Navbar, Nav, NavItem } from 'react-bootstrap';
import { ArrowBack } from '@mui/icons-material';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import CountryContext from './country_context';
import Profile_pic from './images/profile-avatar.png'
import LogoutIcon from '@mui/icons-material/Logout';
import { Logout } from './firebase';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Accordion from '@mui/material/Accordion';

import homeSvg from './svg/material-symbols_home-outline-rounded.svg'
import dogSvg from './svg/material-symbols_sound-detection-dog-barking-outline.svg'
import notificationSvg from './svg/notifications.svg'
import accountSvg from './svg/account.svg'


export const ProfileNavSidePane = (props) => {
    const context = useContext(CountryContext)

    return (
        <div className='container-fluid align-items-center
        justify-content-center  
        pt-2 profile-nav-pane view_height_100'>
            {/* <div className='row align-items-center profile-nav-pane-button py-2 px-3'>
                <img src={homeSvg} alt=""
                    width={"25px"} className='mr-2' />
                Home
            </div> */}
            <div className=' profile-nav-pane-button py-2 px-3 w-100 text-center'>
                {/* <img src={dogSvg} alt=""
                    width={"25px"} className='mr-2' /> */}
                <Link style={{ color: props.color }} 
                className='text-decoration-none w-100 '
                to='/my_dogs'>
                    My Dogs
                </Link>
            </div>

            {/* <div className='profile-nav-pane-button'>
                <Accordion sx={{ boxShadow: "0px 0px 0px 0px" }}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                    >
                        <Typography>Socials</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <div>
                            Posts
                        </div>
                        <div>
                            Friends
                        </div>
                        <div>
                            Messages
                        </div>
                    </AccordionDetails>
                </Accordion>
            </div> */}

            {/* <div className='r profile-nav-pane-button py-2 px-3'>
                <img src={notificationSvg} alt=""
                    width={"25px"} className=' mr-2' />
                Notifications
            </div> */}

            <div className='profile-nav-pane-button py-2 px-3 w-100 text-center'>

                <Link to="/profile/account" className='text-decoration-none'>Account</Link>

            </div>
        </div>
    )
}